export default "__VITE_ASSET__BLLNDJQB__"